import { render, staticRenderFns } from "./TaxRateSelector.vue?vue&type=template&id=118a0507&scoped=true&"
import script from "./TaxRateSelector.vue?vue&type=script&lang=js&"
export * from "./TaxRateSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a0507",
  null
  
)

export default component.exports